var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "custom-modal add-participant-modal",
      attrs: {
        name: "modalSearchParticipant",
        width: "605px",
        height: "auto",
        scrollable: true,
        clickToClose: false
      },
      on: { "before-open": _vm.beforeOpen, "before-close": _vm.beforeClose }
    },
    [
      _c("div", { staticClass: "modal-padding" }, [
        _c(
          "div",
          {
            staticClass: "modal-close-img",
            on: {
              click: function($event) {
                _vm.hideModal()
              }
            }
          },
          [_c("div", { staticClass: "icon-close" })]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [_vm._v("add participant")]),
        _vm._v(" "),
        _c("div", { staticClass: "participant-info" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-6" }, [
              _c("div", { staticClass: "title-field" }, [
                _vm._v("Search for existing participant")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6" }, [
              _c(
                "div",
                { staticClass: "checkbox-container" },
                [
                  !_vm.fromBiometric
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group add-more-services-checkbox",
                          model: {
                            value: _vm.slot.hasBiometric,
                            callback: function($$v) {
                              _vm.$set(_vm.slot, "hasBiometric", $$v)
                            },
                            expression: "slot.hasBiometric"
                          }
                        },
                        [_vm._v("Add biometric screening")]
                      )
                    : _vm.fromBiometric &&
                      _vm.eventDetail.eventSlotGroupsFLuShotOnly.length > 0
                    ? _c(
                        "b-form-checkbox",
                        {
                          staticClass:
                            "ap-checkbox-group add-more-services-checkbox",
                          model: {
                            value: _vm.slot.hasFluShot,
                            callback: function($$v) {
                              _vm.$set(_vm.slot, "hasFluShot", $$v)
                            },
                            expression: "slot.hasFluShot"
                          }
                        },
                        [
                          _vm.fluShot == 1
                            ? [_vm._v("Add flu shot")]
                            : _vm.fluShot == 2
                            ? [_vm._v("Add Covid Vaccine")]
                            : [_vm._v("Add Covid & Flu Shot")]
                        ],
                        2
                      )
                    : _c("span")
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchText,
                    expression: "searchText"
                  }
                ],
                staticClass: "placeholder-italic",
                attrs: {
                  placeholder: "Search by first name, last name or email"
                },
                domProps: { value: _vm.searchText },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.searchText = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "search-icon" })
            ])
          ])
        ]),
        _vm._v(" "),
        _vm.getIsLoadingParticipant === _vm.loadingConstants.LOADING
          ? _c("div", { staticClass: "spinner-loading" }, [_c("Spinner")], 1)
          : _c("div", [
              _vm.filledSlots.length > 0
                ? _c("div", [
                    _c("div", { staticClass: "employee-list-container" }, [
                      _c("div", { staticClass: "list-header" }, [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-md-3" },
                            [
                              _c("HeaderColumn", {
                                attrs: {
                                  headerObject: _vm.arrHeaderObj[0],
                                  sortObject: _vm.sortObject
                                },
                                on: {
                                  CHANGE_SORT_OPTION: _vm.handleChangeSortOption
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-4" },
                            [
                              _c("HeaderColumn", {
                                attrs: {
                                  headerObject: _vm.arrHeaderObj[1],
                                  sortObject: _vm.sortObject
                                },
                                on: {
                                  CHANGE_SORT_OPTION: _vm.handleChangeSortOption
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-md-3" },
                            [
                              _c("HeaderColumn", {
                                attrs: {
                                  headerObject: _vm.arrHeaderObj[2],
                                  sortObject: _vm.sortObject
                                },
                                on: {
                                  CHANGE_SORT_OPTION: _vm.handleChangeSortOption
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("div", { staticClass: "field-col" }, [
                              _c("div", {
                                staticClass: "caption-text label-text"
                              })
                            ])
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "list-participant-row" }, [
                        _c(
                          "div",
                          [
                            _vm._l(_vm.filledSlots, function(p, index) {
                              return [
                                _c("ParticipantTableInfo", {
                                  key: index,
                                  attrs: {
                                    slot: _vm.slot,
                                    requestUpdateTable: _vm.requestUpdateTable,
                                    eventId: _vm.eventId,
                                    participant: p,
                                    fluShot: _vm.fluShot
                                  },
                                  slot: _vm.slot
                                })
                              ]
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                : _vm._e()
            ]),
        _vm._v(" "),
        _vm.isShowingText &&
        _vm.searchText &&
        _vm.getIsLoadingParticipant === _vm.loadingConstants.LOADED
          ? _c("div", { staticClass: "btn-add-container" }, [
              _vm.isEnableButton
                ? _c("div", { staticClass: "display-text" }, [
                    !_vm.isFoundParticipant
                      ? _c("div", [
                          _vm._v(
                            '\n          "' +
                              _vm._s(_vm.searchText) +
                              '" could not be found.'
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          You can create and add a participant to the slot.\n        "
                          )
                        ])
                      : _c("div", { staticClass: "display-text" }, [
                          _vm._v(
                            "\n          If the participant you are looking for is not listed."
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          You can create and add a new participant.\n        "
                          )
                        ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "margin-top-24px" }, [
                      _c(
                        "button",
                        {
                          staticClass: "ap-btn primary btn-add-participant",
                          on: {
                            click: function($event) {
                              _vm.addNewParticipant()
                            }
                          }
                        },
                        [_vm._v("Create & Add Participant")]
                      )
                    ])
                  ])
                : _c("div", { staticClass: "display-text" }, [
                    _vm._v(
                      '\n        "' +
                        _vm._s(_vm.searchText) +
                        '" could not be found.'
                    ),
                    _c("br"),
                    _vm._v(
                      "\n        Please contact your HR representative to add the participant.\n      "
                    )
                  ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1cbc7750", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cbc7750","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/patient/SearchParticipantModal.vue
// module id = 1726
// module chunks = 1